module.exports = __webpack_public_path__ + "static/img/Logo Bible_Search_Blue_Circle.05bd7c28.png";